import { useQuery } from 'react-query';
import { ValueOf } from 'type-fest';

import {
  useRequest,
  type QueryFunction,
  type BasePartCardData,
  REQS_REVIEW_RESOLUTION_TYPES,
  type BaseUser,
} from '@frontend/api';

type ComponentLite = {
  id: number;
  quoteItemId: number;
  quoteNumberWithRevision: string;
  part: BasePartCardData;
  partNumber: string;
  revision: string;
  description: string;
  isAssembly: boolean;
  isExportControlled: boolean;
  isRootComponent: boolean;
};

type RuleLite = {
  uuid: string;
  name: string;
  description: string;
  resolutionTypes: ValueOf<typeof REQS_REVIEW_RESOLUTION_TYPES>[];
};

export type ActionDashboardItem = {
  uuid: string;
  component: ComponentLite;
  rule: RuleLite;
  assignedAutomatically: boolean;
  assignedAt: string | null;
  assignedBy: BaseUser | null;
  commentCount: number;
  groupId: number;
};

type ActionsDashboardResponse = {
  results: ActionDashboardItem[];
  count: number;
};

type ActionsListDashboardQueryParams = {
  page: number;
  pageSize: number;
};

export const getUseGetActionsDashboardKey = (
  params: ActionsListDashboardQueryParams,
) => ['actions', 'dashboard'].concat([JSON.stringify(params)]);

export const useGetActionsDashboard: QueryFunction<
  ActionsDashboardResponse,
  [ActionsListDashboardQueryParams],
  ReturnType<typeof getUseGetActionsDashboardKey>
> = (params, { queryOptions, requestOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getUseGetActionsDashboardKey(params),
    queryFn: ({ signal }) => {
      return request<ActionsDashboardResponse>(`/rules/actions/dashboard/`, {
        query: params,
        init: {
          signal,
        },
      });
    },
  });
};
